var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterfall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 44.6248H6.375",
    stroke: "url(#paint0_linear_1146_2385)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 34V29.75",
    stroke: "url(#paint1_linear_1146_2385)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25.5V19.125",
    stroke: "url(#paint2_linear_1146_2385)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 34V21.25",
    stroke: "url(#paint3_linear_1146_2385)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 27.6248V23.3748",
    stroke: "url(#paint4_linear_1146_2385)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 31.8748V10.6248",
    stroke: "url(#paint5_linear_1146_2385)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1146_2385",
    x1: 6.375,
    y1: 45.1248,
    x2: 44.625,
    y2: 45.1248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1146_2385",
    x1: 8.5,
    y1: 31.875,
    x2: 9.5,
    y2: 31.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1146_2385",
    x1: 25.5,
    y1: 22.3125,
    x2: 26.5,
    y2: 22.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1146_2385",
    x1: 17,
    y1: 27.625,
    x2: 18,
    y2: 27.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1146_2385",
    x1: 34,
    y1: 25.4998,
    x2: 35,
    y2: 25.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1146_2385",
    x1: 42.5,
    y1: 21.2498,
    x2: 43.5,
    y2: 21.2498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterfall);
export default __webpack_public_path__ + "static/media/Waterfall.af93490dfba3f34a36553515121a41bc.svg";
export { ForwardRef as ReactComponent };